import { z } from "zod";

export const FrameworkEffectivenessScopeSchema = z.enum(["persona_company", "company", "none"]);

export const FrameworkEffectivenessItemSchema = z.object({
	frameworkName: z.string(),
	totalUses: z.number().int().nonnegative(),
	replyRatePct: z.number().min(0).max(100),
	positiveSentimentRatePct: z.number().min(0).max(100),
	meetingBookedRatePct: z.number().min(0).max(100),
});

export const FrameworkEffectivenessSummarySchema = z.object({
	scope: FrameworkEffectivenessScopeSchema,
	items: z.array(FrameworkEffectivenessItemSchema),
});

export type FrameworkEffectivenessScope = z.infer<typeof FrameworkEffectivenessScopeSchema>;
export type FrameworkEffectivenessItem = z.infer<typeof FrameworkEffectivenessItemSchema>;
export type FrameworkEffectivenessSummary = z.infer<typeof FrameworkEffectivenessSummarySchema>;

export interface FrameworkEffectivenessQueryParams {
	personaCategory?: string;
	companyCategory?: string;
}
